import { Form, Modal } from "antd";
import React from "react";
import { CreateTaxEmissionDto } from "../../../api";
import { TaxEmissionsColumns } from "../form/columns";

interface TaxEmissionFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateTaxEmission: (values: CreateTaxEmissionDto) => void;
}

export const TaxEmissionForm: React.FC<TaxEmissionFormProps> = ({ visible, setVisible, onCreateTaxEmission }) => {
  const [form] = Form.useForm<CreateTaxEmissionDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateTaxEmission}>
        {TaxEmissionsColumns().map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
          {inputNode}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
